export const post = async (url, token, data, json = false) => {
  let body
  const myHeaders = new Headers()
  myHeaders.append('Authorization', 'Bearer ' + token)
  if (json) {
    body = JSON.stringify(data)
    myHeaders.append('Content-Type', 'application/json')
  } else {
    body = new FormData()
    Object.keys(data).forEach((key) => body.append(key, data[key]))
  }
  const response = await fetch(url, {
    method: 'POST',
    body: body,
    headers: myHeaders,
  })
  if (!response.ok) {
    console.error('Request failed:', response)
  }
  try {
    return await response.json()
  } catch (error) {
    console.error('Request failed:', error)
    return null
  }
}

export const rpc = async (url, token, data) => {
  const myHeaders = new Headers()
  myHeaders.append('Authorization', 'Bearer ' + token)
  var urlencoded = new URLSearchParams()

  Object.keys(data).forEach((key) => urlencoded.append(key, data[key]))
  const response = await fetch(url, {
    method: 'POST',
    body: urlencoded,
    headers: myHeaders,
  })
  if (!response.ok) {
    console.error('Request failed:', response)
  }
  try {
    return await response.json()
  } catch (error) {
    console.error('Request failed:', error)
    return null
  }
}
export const del = async (url, token) => {
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
  if (response.ok) {
    console.log(response.statusText)
  } else {
    console.error('Request failed:', error)
  }
  return response
}

export const put = async (url, token, data) => {
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
  return response
}
